import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  makeStyles,
} from '@material-ui/core'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import TicketItem from './TicketItem'

const TicketAccordion = ({
  archived,
  tickets,
  title,
  linkable_type,
  coproprietaire,
}) => {
  const useStyles = makeStyles({
    icons: {
      width: '32px',
      marginRight: '8px',
    },
    accordion: {
      boxShadow: 'none!important',
      margin: '16px auto!important',
      '&:not(.Mui-disabled), .MuiStepper-root': {
        backgroundColor: '#f2f2f2!important',
      },
      borderRadious: '1rem!important',
    },
    processCard: {
      border: 'none',
      boxShadow: 'none',
      '& .MuiCardContent-root': {
        padding: '0 16px!important',
      },
    },
  })
  const classes = useStyles()

  return (
    <Accordion
      className={classes.accordion}
      defaultExpanded={false}
      disabled={tickets.length === 0}
    >
      <AccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>
        <List style={{ width: '100%' }}>
          {tickets
            .filter((item) => item.archived === archived)
            .map((ticket) => (
              <TicketItem
                coproprietaire={coproprietaire}
                linkable_type={linkable_type}
                ticket={ticket}
                process={{ name: 'Mise en concurrence' }}
              />
            ))}
        </List>
      </AccordionDetails>
    </Accordion>
  )
}
export default TicketAccordion
